import { render, staticRenderFns } from "./GrowthArticle.vue?vue&type=template&id=0fcdf534&scoped=true&"
import script from "./GrowthArticle.vue?vue&type=script&lang=js&"
export * from "./GrowthArticle.vue?vue&type=script&lang=js&"
import style0 from "./GrowthArticle.vue?vue&type=style&index=0&id=0fcdf534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcdf534",
  null
  
)

export default component.exports